module.exports = __webpack_public_path__ + "img/zaisu_four.b05fd355.jpg";